<section
  [attr.id]="anchorLink ? anchorLink : null"
  class="text-info__section"
  [style.background]="sectionBackground"
>
  <div class="text-info__container">
    @for (content of contents; track content; let i = $index) {
      <app-info-text
        [title]="content.title"
        [subtitle]="content.subtitle"
        [description]="content.description"
        [useLargeHeading]="useLargeHeading && i === 0"
      >
      </app-info-text>
    }
    @if (!contents || !contents.length) {
      <app-info-text
        [title]="title"
        [subtitle]="subtitle"
        [description]="description"
        [useLargeHeading]="useLargeHeading"
      >
      </app-info-text>
    }
  </div>
</section>
